module.exports = __webpack_public_path__ + "img/small-owl_2.9a60c853.jpg";